import * as React from 'react';
import Card from '@mui/material/Card';
import Icn from './Icn';
import Btn from './Btn';
import { colors } from '../maps/colors';
import Tx from './Tx';
import CameraLive from './camera/CameraLive';

export default function InstallerCameraCard(props) {

    const { camera, onSelect, hideActionButtons } = props;
    const { profile_list, streamFullRtspUrl } = camera;

    const getCameraSnapshot = () => {
        let url = '';

        url = profile_list?.length && profile_list[0].snapshot;

        return url;
    }

    return (
        <Card sx={{ width: '100%', marginBottom: '5px', background: camera.selected ? colors.LIGHT_GREEN + "50" : 'white' }}>
            <div style={{ padding: 5 }}>
                <Icn style={{ position: 'relative', top: 4 }}>camera</Icn> <span style={{ fontSize: 18, fontWeight: 500 }}>{camera.name}</span>
            </div>
            <div style={{ padding: 3 }}>
                <table style={{ fontSize: 12 }}>
                    <tbody>
                        {
                            camera.connectionType == 'MANUAL' && <>
                                <tr>
                                    <td><Tx>camera.rtspUrl</Tx>:</td>
                                    <td>{camera.rtspUrl}</td>
                                </tr>
                            </>
                        }

                        {
                            camera.connectionType == 'ONVIF' && <>
                                <tr>
                                    <td><Tx>camera.ip</Tx>:</td>
                                    <td>{camera.ip}</td>
                                </tr>
                            </>
                        }

                    </tbody>
                </table>
                {
                    streamFullRtspUrl && <CameraLive rtspUrl={streamFullRtspUrl} resolution={`${profile_list[0].video.encoder.resolution.width}x${profile_list[0].video.encoder.resolution.height}`}/>
                }
            </div>
            {!hideActionButtons && (
                <div style={{ padding: 5 }}>
                    <Btn startIcon="camera" onClick={() => props.onSelect(camera)}><Tx>g.select</Tx></Btn>
                </div>
            )}
        </Card >
    );
}